import { AuthenticateUserType } from '../../../utils/idbFns';

export type OrganisationSwitchStore = {
  readProfile: (userId: string) => Promise<AuthenticateUserType>;
  writeProfile: (profile: AuthenticateUserType, userId: string) => Promise<unknown>;
  writeCookie: (token: string) => void;
};

// Stores only the token the server returned. A missing token is a refused switch.
export const applyOrganisationSwitch = async (
  store: OrganisationSwitchStore,
  userId: string,
  serverToken: string | null | undefined
) => {
  if (!serverToken) {
    throw new Error('Unable to switch organisation.');
  }
  const profile = await store.readProfile(userId);
  if (profile) {
    profile.token = serverToken;
    await store.writeProfile(profile, userId);
  }
  store.writeCookie(serverToken);
  return serverToken;
};
